// Настройки → Данные: скачать все свои данные одним JSON.

import { useMutation } from '@tanstack/react-query'

import { Button, Card, ErrorText, useToast } from '@/components/ui'
import { formatBytes } from '@/pages/settings/backups/logic'

import { downloadExport } from './download'

export function DataPage() {
  const toast = useToast()
  const download = useMutation({
    mutationFn: downloadExport,
    onSuccess: (res) => toast.show({ message: `Файл ${res.filename} скачан (${formatBytes(res.size)})`, tone: 'accent' }),
  })
  return (
    <div className="grid max-w-3xl gap-4">
      <Card
        title="Все мои данные"
        subtitle="Один JSON-файл со всеми записями: вес и замеры, здоровье, тренировки, план, цели, данные Garmin, отчёты ИИ и журнал изменений."
      >
        <p className="text-sm text-muted">
          В файле нет паролей, токенов, хешей и ключей доступа — только сами данные. Файл можно открыть любым редактором или
          загрузить в другую программу.
        </p>
        <div className="mt-4">
          <Button variant="primary" icon="download" loading={download.isPending} onClick={() => download.mutate()}>
            Скачать все данные
          </Button>
        </div>
        <ErrorText error={download.error} className="mt-3" />
      </Card>
    </div>
  )
}
